function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import { useMemo } from 'react';
import { EU_CONSENT_PREFERENCES_COOKIE, DEFAULT_CONSENT_PREFERENCES_COOKIE } from '../constants.js';
import { useCookie } from '../CookieContext.js';
import { useTrackingManager } from '../TrackingManagerContext.js';
import { getAppTrackingTransparencyFromQueryParams } from '../utils/persistMobileAppPreferences.js';
const useSavedTrackingPreferenceFromMobileApp = () => {
  const _useTrackingManager = useTrackingManager(),
    region = _useTrackingManager.region;
  const _useCookie = useCookie('is_mobile_app'),
    _useCookie2 = _slicedToArray(_useCookie, 1),
    isMobileAppFromCookie = _useCookie2[0];
  const isMobileAppFromQueryParams = useMemo(() => getAppTrackingTransparencyFromQueryParams(), []);
  const isWebView = typeof window !== 'undefined' && !!window.isWebView;
  const isMobileApp = isMobileAppFromCookie || isMobileAppFromQueryParams || isWebView;
  const mobileAppPreference = useMemo(() => {
    if (isMobileApp) return {
      region,
      consent: ['necessary']
    };
  }, [isMobileApp, region]);
  return mobileAppPreference;
};
const useSavedTrackingPreference = () => {
  const _useTrackingManager2 = useTrackingManager(),
    region = _useTrackingManager2.region,
    onError = _useTrackingManager2.onError;
  const _useCookie3 = useCookie(EU_CONSENT_PREFERENCES_COOKIE),
    _useCookie4 = _slicedToArray(_useCookie3, 1),
    euCookie = _useCookie4[0];
  const _useCookie5 = useCookie(DEFAULT_CONSENT_PREFERENCES_COOKIE),
    _useCookie6 = _slicedToArray(_useCookie5, 1),
    defaultCookie = _useCookie6[0];
  const preference = region === 'EU' ? euCookie : defaultCookie;
  if (!preference) {
    return;
  }
  if (!preference.region || !preference.consent) {
    onError(new Error('Malformed preferences'));
    return;
  }
  return preference;
};
export { useSavedTrackingPreference as default, useSavedTrackingPreferenceFromMobileApp };
//# sourceMappingURL=useSavedTrackingPreference.js.map
